import { linkToMonitoringOverviewPage } from "../../links";

export function linkToInviteChildren() {
  return `${linkToMonitoringOverviewPage()}/invite-children`;
}
